import React from 'react';
import styles from './loader.module.scss';

const LoaderComponent = () => <div className={ styles.loader } />;

export const FullLoader = () => <div className={styles.loaderContainer}><LoaderComponent /></div>

export default LoaderComponent;
